import { CreateBase, SimpleForm } from 'react-admin';

import { MunicipalityInputs } from './MunicipalityInputs';
import { MunicipalityFormCard } from './MunicipalityFormCard';

// Not mounted as a react-admin Resource route — redirect uses the explicit
// Settings path so react-admin doesn't navigate to the unregistered /municipalities.
export const MunicipalityCreate = () => (
    <CreateBase resource="municipalities" redirect="/settings/municipalities">
        <MunicipalityFormCard>
            <SimpleForm sanitizeEmptyValues>
                <MunicipalityInputs />
            </SimpleForm>
        </MunicipalityFormCard>
    </CreateBase>
);
